import { AxiosRequestConfig } from 'axios';
import { InvestmentPageKey, InvestmentPageListType } from '../../types';
import { requester } from '../config';

export type FetchInvestmentPageDataParams = {
  page: InvestmentPageKey;
  listtype: InvestmentPageListType;
  searchtext: string;
  limit?: number;
};

export const fetchInvestmentPageData = (
  data: FetchInvestmentPageDataParams,
  {
    limit = 10,
    start = 0,
    ...config
  }: { limit?: number; start?: number } & AxiosRequestConfig = {}
) =>
  requester.post(
    '/investment_list',
    {
      limit,
      start,
      ...data
    },
    config
  );

export const fetchInvestmentData = (
  id: string,
  config: AxiosRequestConfig = {}
) =>
  requester.post(
    '/investment_page',
    {
      id,
      loadtype: 'showonlyinfo'
    },
    config
  );

export const toggleFollowInvestment = (
  id: string,
  followstatus: 0 | 1,
  config: AxiosRequestConfig = {}
) =>
  requester.post(
    '/investment_page',
    {
      id,
      loadtype: 'action',
      action: 'tooglefollow',
      actiondata: { followstatus }
    },
    config
  );

export const fetchInvestmentPage = (
  id: string,
  {
    loadtype,
    info,
    ...config
  }: { loadtype: string; info?: any } & AxiosRequestConfig
) =>
  requester.post(
    '/investment_page',
    {
      id,
      loadtype,
      ...(info ? { info } : {})
    },
    config
  );
